import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import './ExpertForm.css';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function EditExpertForm({ expert, onSubmit, onClose }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    expertId: expert.expertId,
    name: expert.name,
    email: expert.email,
    password: expert.password,
    meetingCharge: expert.meetingCharge,
    phone: expert.phone,
    address: expert.address || '',
    profession: expert.profession || '',
    category: expert.category || '',
    experience: expert.experience || '',
    qualifications: expert.qualifications || '',
    resumeDocName: '',
    proofDocName: '',
    profileImageName: '',
    newResumeDocName: '',
    newProofDocName: '',
    newProfileImageName: '',
    resumeDoc: null,
    proofDoc: null,
    profileImage: null,
    isApproved: expert.isApproved || false
  });

  useEffect(() => {
    // Update form data if expert prop changes
    setFormData({
      expertId: expert.expertId,
      name: expert.name,
      email: expert.email,
      password: expert.password,
      meetingCharge: expert.meetingCharge,
      phone: expert.phone,
      address: expert.address || '',
      profession: expert.profession || '',
      category: expert.category || '',
      experience: expert.experience || '',
      qualifications: expert.qualifications || '',
      resumeDocName: expert.resumeDocName || '',
      proofDocName: expert.proofDocName || '',
      profileImageName: expert.profileImageName || '',
      newResumeDocName: '',
      newProofDocName: '',
      newProfileImageName: '',
      resumeDoc: null,
      proofDoc: null,
      profileImage: null,
      isApproved: expert.isApproved || false
    });
  }, [expert]);

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleResumeFileChange = (e) => {
    const { files } = e.target;

    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed

    setFormData((prev) => ({
      ...prev,
      ['resumeDoc']: files[0],
      [`newResumeDocName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };
  const handleProofFileChange = (e) => {
    const { files } = e.target;

    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed

    setFormData((prev) => ({
      ...prev,
      ['proofDoc']: files[0],
      [`newProofDocName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };

  const handleProfileFileChange = (e) => {
    const { files } = e.target;

    // Generate a smaller UUID
    const smallUUID = uuidv4().slice(0, 8); // Adjust length as needed

    setFormData((prev) => ({
      ...prev,
      ['profileImage']: files[0],
      [`newProfileImageName`]: `${smallUUID}_${files[0].name}`, // Dynamically set doc name based on input name
    }));
  };

  const handleApprovedToggle = async () => {
    const updatedApprovalStatus = !formData.isApproved;

    try {
      const response = await axios.put(`${BASE_URL}/expert/approveExpertDetails.php`, {
        expertId: formData.expertId,
        email: formData.email,
        name: formData.name,
        isApproved: updatedApprovalStatus, // Send the updated status
      });

      if (response.data.success) {
        // Update the form data locally after server confirmation
        setFormData((prev) => ({
          ...prev,
          isApproved: updatedApprovalStatus,
        }));
      } else {
        console.error("Failed to toggle approval:", response.data.error);
      }
    } catch (error) {
      console.error("Error toggling approval:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const submissionData = new FormData();
    Object.keys(formData).forEach(key => {
      submissionData.append(key, formData[key]);
    });

    onSubmit(submissionData);
  };

  return (
    <div className="expert-form-overlay">
      <div className="expert-form">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>Edit Expert Details</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div className="email-verify">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="show-password-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Phone:</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Address:</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Meeting Charge:</label>
            <input
              type="number"
              name="meetingCharge"
              value={formData.meetingCharge}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Profession:</label>
            <input
              type="text"
              name="profession"
              value={formData.profession}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Category:</label>
            <input
              type="text"
              name="category"
              value={formData.category}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Experience:</label>
            <textarea
              name="experience"
              value={formData.experience}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Qualifications:</label>
            <textarea
              name="qualifications"
              value={formData.qualifications}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label>Resume Document:</label>
            {expert.resumeDocName && (
              <>
                {['png', 'jpeg', 'jpg'].some(ext => expert.resumeDocName.endsWith(ext)) ? (
                  <img
                    src={`${BASE_URL}/images/resume/${expert.resumeDocName}`}
                    alt="Resume Preview"
                    className="image-preview"
                    onClick={() => handleImageClick(`${BASE_URL}/images/resume/${expert.resumeDocName}`)}
                  />
                ) : (
                  <a
                    href={`${BASE_URL}/images/resume/${expert.resumeDocName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Document
                  </a>
                )}
              </>
            )}
            <input
              type="file"
              name="resumeDoc"
              onChange={handleResumeFileChange}
              accept=".png,.jpeg,.jpg,.pdf,.doc"
            />
          </div>

          <div className="form-group">
            <label>Proof Document:</label>
            {expert.proofDocName && (
              <>
                {['png', 'jpeg', 'jpg'].some(ext => expert.proofDocName.endsWith(ext)) ? (
                  <img
                    src={`${BASE_URL}/images/proof/${expert.proofDocName}`}
                    alt="Proof Preview"
                    className="image-preview"
                    onClick={() => handleImageClick(`${BASE_URL}/images/proof/${expert.proofDocName}`)}
                  />
                ) : (
                  <a
                    href={`${BASE_URL}/images/proof/${expert.proofDocName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Document
                  </a>
                )}
              </>
            )}
            <input
              type="file"
              name="proofDoc"
              onChange={handleProofFileChange}
              accept=".png,.jpeg,.jpg,.pdf,.doc"
            />
          </div>

          <div className="form-group">
            <label>Profile Image:</label>
            {expert.profileImageName && (
              <>
                {['png', 'jpeg', 'jpg'].some(ext => expert.profileImageName.endsWith(ext)) ? (
                  <img
                    src={`${BASE_URL}/images/profile/${expert.profileImageName}`}
                    alt="Profile Preview"
                    className="image-preview"
                    onClick={() => handleImageClick(`${BASE_URL}/images/profile/${expert.profileImageName}`)}
                  />
                ) : (
                  <a
                    href={`${BASE_URL}/images/profile/${expert.profileImageName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Document
                  </a>
                )}
              </>
            )}
            <input
              type="file"
              name="profileImage"
              onChange={handleProfileFileChange}
              accept=".png,.jpeg,.jpg,.pdf,.doc"
            />
          </div>


          {/* Modal for Full Image */}
          {selectedImage && (
            <div className="image-modal-overlay" onClick={closeModal}>
              <div className="image-modal-content">
                <img src={selectedImage} alt="Full View" className="full-image" />
              </div>
            </div>
          )}
          <div className="form-group">
            <label>Approved:</label>
            <div className="toggle-container">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={formData.isApproved}
                  onChange={handleApprovedToggle}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <button type="submit">Update Expert</button>
        </form>
      </div>
    </div>
  );
}

export default EditExpertForm;
